module.exports = __webpack_public_path__ + "img/donante-sol-de-mexico.3b24066a.png";